
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/broadcaster/playlistPlayer",
      function () {
        return require("private-next-pages/broadcaster/playlistPlayer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/broadcaster/playlistPlayer"])
      });
    }
  